import App from "../App";
import Active from "../pages/Active";
import Hover from "../pages/Hover";
import Load from "../pages/Load";
import Page from "../pages/Page";

export const router = [
    {
        path: "/",
        element: <App />,
    },
    {
        path: "*",
        element: <App />,
    },
    {
        path: "/load-animation",
        element: <Load />,
    },
    {
        path: "/hover-animation",
        element: <Hover />,
    },
    {
        path : "/active-component",
        element: <Active />
    },
    {
        path : "/page-transition",
        element: <Page />
    }
]

